import MuiBox, { type BoxProps } from "@mui/material/Box";

export type { BoxProps };

export const Box = MuiBox;
